<template>
	<div style="width: 100%; height: 100%; background-color: #f4f4f5">
		<!-- van-pull-refresh             :success-duration="1000"     v-model="isLoading"       @refresh="getModelData"-->
		<div v-show="showMain" style="height: 100%">
			<div class="man-container" v-if="active" style="overflow-y: auto; height: calc(100% - 60px)">
				<div id="top"></div>
				<div class="content">
					<fee-info :item="modelData" ref="feeInfo" @changeSumMoney="changeSumMoney"></fee-info>
				</div>
				<div v-show="isNeedInvoice" class="content" style="margin-top: 10px">
					<ticket-info
						ref="ticket-info"
						:detail="detail"
						:chooceJG="chooceJG"
						@add-organ="addOrgan"
						@changeTicketType="changeTicketType"
						@search-organ="searchOrgan"></ticket-info>
				</div>
				<div v-show="isNeedInvoice" class="content">
					<ticket-notice :item="modelData" ref="ticketNotice"></ticket-notice>
				</div>
				<div id="down"></div>
			</div>
			<div class="footer">
				<ticket-confirm
					:detail="detail"
					v-if="active"
					:showCancel="false"
					@commit="onCommit"
					style="padding-right: 10px"></ticket-confirm>
			</div>
		</div>
		<van-loading color="#005423" style="min-height: 300px; line-height: 300px" v-if="!active" />
		<div class="pay-confirm-full" style="height: 100%; overflow-y: hidden" v-if="!showMain && active">
			<ticket-add v-if="showAdd" @back="onBack" @select="select"></ticket-add>
			<ticket-search v-else @back="onBack" @select="select"></ticket-search>
		</div>
	</div>
</template>
<script>
import apiChooseFee from 'api/choose-fee'
import feeInfo from './comps/feeInfo'
import ticketInfo from './comps/ticketInfo'
import ticketNotice from './comps/ticketNotice'
import TicketAdd from '@/components/ticket-add/index'
import TicketSearch from '@/components/ticker-search/index'
import ticketConfirm from '@/components/ticket-confirm/index'
import util from 'utils/util'
import db from 'utils/db'
import Vue from 'vue'

export default {
	components: {
		feeInfo,
		ticketInfo,
		TicketAdd,
		TicketSearch,
		ticketConfirm,
		ticketNotice
	},
	data() {
		return {
			range: '',
			sc: '', //收费场景，一般都是二维码支付，不过为了给首信易支付进行识别，特此加上此参数
			isLoading: false,
			modelData: {},
			detail: {},
			showMain: false,
			active: false,
			showAdd: true,
			chooceJG: false,
			enableClickSubmit: true,
			isShowDialog: false,
			isNeedInvoice: true,
			noticeInfo: {
				email: '',
				phone: ''
			}
		}
	},
	methods: {
		changeTicketType(val) {
			this.$nextTick(() => {
				if (val === 2) {
					document.getElementById('down').scrollIntoView(false)
				} else {
					document.getElementById('top').scrollIntoView()
				}
			})
		},
		changeSumMoney(money) {
			Vue.set(this.detail, 'allMoney', money)
		},
		submitFun(param) {
			apiChooseFee
				.submitUnname(param)
				.then(res => {
					console.log(res)
					this.enableClickSubmit = false
					let divForm = document.getElementsByTagName('divform')
					if (divForm.length) {
						document.body.removeChild(divForm[0])
					}
					const div = document.createElement('divform')
					div.innerHTML = res.data
					document.body.appendChild(div)
					document.forms[0].submit()
				})
				.catch(err => {
					this.enableClickSubmit = false
				})
		},
		onCommit() {
			if (!this.enableClickSubmit) {
				return
			}
			let pendFees = this.$refs.feeInfo.getParam()
			if (!pendFees) {
				return
			}
			let data = this.$refs['ticket-info'].getTicketTitleAndTaxNum()
			let {
				title,
				taxNumber,
				invoiceIsDelay,
				depositBank,
				tele,
				bank,
				address,
				remark,
				estateStartDate,
				estateEndDate
			} = data
			let { email } = this.$refs['ticketNotice'].getParam()
			if (title && title.trim() == '中山大学') {
				this.$notify({
					type: 'warning',
					message: this.$t('pay_ticket.title_not_sysu')
				})
				return
			}
			if (taxNumber && taxNumber.trim() == '121000004558631445') {
				this.$notify({
					type: 'warning',
					message: this.$t('pay_ticket.tax_number_not_sysu')
				})
				return
			}
			if (this.detail.estate && !this.detail.estateAddr) {
				this.$notify({
					type: 'warning',
					message: this.$t('pay_ticket.estate_addr_lost')
				})
				return
			}
			if (this.detail.estate && (estateStartDate == '' || estateEndDate == '')) {
				this.$notify({
					type: 'warning',
					message: this.$t('pay_ticket.estate_date_needed')
				})
				return
			}
			if (!this.isNeedInvoice || title || invoiceIsDelay === 1) {
				const currentLang = db.get('sys.public.language.value').value() || 'zh'
				this.enableClickSubmit = false
				let param = {
					allMoney: this.detail.allMoney,
					ticketTitle: title,
					pendFees: pendFees,
					userRegNum: taxNumber,
					userAddress: address,
					userTele: tele,
					userEmail: email,
					userBank: bank,
					invoiceIsDelay: invoiceIsDelay,
					estateStartDate: estateStartDate,
					estateEndDate: estateEndDate,
					estateAddr: this.detail.estateAddr,
					estateDetailAddr: this.detail.estateDetailAddr,
					remark: remark,
					sucUrl: util.getIpUrl(this) + '/result/pay_suc?type=3',
					lang: currentLang
				}
				if (this.sc != '') {
					param.scene = this.sc
				}
				this.submitFun(param)
			} else {
				this.$notify({
					type: 'warning',
					message: this.$t('message.ticketTitle')
				})
			}
		},
		onBack() {
			this.showMain = true
		},
		select(item) {
			this.onBack()
			let keys = Object.keys(item)
			this.$nextTick(() => {
				keys.forEach(key => {
					this.$set(this.detail, key, item[key])
				})
			})
		},
		reset() {
			this.modelData = {}
			this.detail = {}
			this.active = false
		},
		getModelData() {
			this.reset()
			this.isLoading = true
			let startTime = new Date()
			apiChooseFee.topayInfo({ range: this.range }, { timeout: 60000 }).then(res => {
				let data = res.data
				this.modelData = data
				this.detail.enableUseCompanyTitle = data.enableUseCompanyTitle
				this.detail.estate = data.estate
				this.detail.estateAddr = data.estateAddr
				this.detail.estateDetailAddr = data.estateDetailAddr
				this.showMain = true
				this.isNeedInvoice = data.ticketTypeId && data.ticketTypeId != undefined && data.ticketTypeId != null
				this.handle(startTime)
			})
			this.$nextTick(() => {
				this.isLoading = false
			})
		},
		handle(startTime) {
			this.$nextTick(() => {
				let t = 100 - (new Date() - startTime)
				if (t > 0) {
					setTimeout(() => {
						this.active = true
					}, t)
				} else {
					this.active = true
				}
			})
		},
		getDefaultTitle() {
			apiChooseFee.defaultTitle({ code: 'TICKET_BILL_RISE' }).then(res => {
				let data = res.data
				if (data) {
					Vue.set(this.detail, 'userName', data.value)
				}
			})
		},
		addOrgan() {
			this.showMain = false
			this.showAdd = true
			this.chooceJG = true
		},
		searchOrgan() {
			this.showMain = false
			this.showAdd = false
			this.chooceJG = true
		}
	},
	created() {
		this.range = this.$route.query.range
		let sc = this.$route.query.sc
		if (sc) {
			this.sc = sc
		}
		this.showMain = false
		this.getModelData()
	},
	mounted() {
		let this_protocal = location.protocol
		if (this_protocal == 'http') {
			let newUrl = location.href.replace('http', 'https')
			window.location.href = newUrl
		}
	}
}
</script>
<style type="text/css">
.align-left-col {
	text-align: left;
	padding-left: 2px;
}

.van-pull-refresh__track {
	height: 100%;
}

.footer {
	position: absolute;
	bottom: 0px;
	width: 100%;
	height: 60px;
}

/*.footer .summary, .footer .btn-text {*/
/*    font-size: 22px;*/
/*}*/

.footer .btn-text {
	width: 80px;
}
</style>
